<template>
    <div class="" style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-1">
                        <br>
                        <i class="bi bi-chevron-left" onclick="window.location.href = '/auth'"></i>
                    </div>
                    <div class="col">
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap">
            <div class="container" style="padding-top:56px;">
                <br>
                <div class="row justify-content-center">
                    <div class="col-11">
                        <div style="font-size:30px;color:#6C7072;">
                            メールアドレスを<br>
                            入力してください
                        </div>
                    </div>
                </div>
                <br>
                <br>
                <div class="row justify-content-center">
                    <div class="col-11">
                        <p class="error-text" id="error-box" v-if="is_login_error">
                            <i class="bi bi-x-circle-fill"></i>すでに登録されているメールアドレスです
                        </p>
                        <input type="email" class="luna-form-control" id="mail" name="mail" placeholder="sample@example.com"
                            v-model="email" />
                        <br />
                        <div class="" style="padding:15px; font-size:15px;color:#6C7072;">
                            {{ user.name }}様<br>
                            メール認証の設定をお願いいたします。<br>
                            有料会員様は決済時に記入いただいたメールアドレスのご記載をお願いします。<br><br>
                            次の画面にすすむとregister@luna_matching.com<br>
                            からメールアドレスの認証用メールが送信されます。<br><br>
                            <div class="form-check">
                                <input class="form-check-input-luna" type="checkbox" id="flexCheckSkip"
                                    v-bind:checked="flexCheckSkip" v-on:change="flexCheckSkip = !flexCheckSkip" />
                                <label class="form-check-label label-box" for="flexCheckSkip"
                                    style="padding-left: 5px; padding-top: 6px">
                                    <small> メール認証の設定をスキップします。 </small>
                                </label>
                            </div>
                        </div>
                        <br />
                        <br />
                        <div class="d-grid gap-2" style="padding: 0 5px;">
                            <button type="button" class="btn btn-luna" style="font-size:18px; padding:12px 0;"
                                @click="setSkip()" v-if="flexCheckSkip">次へ</button>
                            <button type="button" class="btn btn-luna-d disabled" style="font-size:18px; padding:12px 0;"
                                v-else-if="isInValidEmail">次へ</button>
                            <button type="button" class="btn btn-luna" style="font-size:18px; padding:12px 0;"
                                @click="setAuth()" v-else>次へ</button>
                        </div>
                        <br />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            is_login_error: false,
            email: "",
            user: [],
            page_type: 0,
            flexCheckSkip: false,
        };
    },
    methods: {
        async setSkip() {
            await axios.post("/api/auth/skip/set", {
                email: this.email,
            })
                .then((response) => {
                    window.location.href = "/search"
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("メールの送信に失敗しました")
                    }
                })
        },
        async setAuth() {
            await axios.post("/api/auth/check/set", {
                email: this.email,
            })
                .then((response) => {
                    if (response.data.res == '546') {
                        this.is_login_error = true
                    }
                    else {
                        window.location.href = "/auth/send/" + this.email
                    }
                })
                .catch((error) => {
                    this.$showErrorToast("メールの送信に失敗しました")
                })
        },
        async init() {
            await axios.get("/api/auth/user/get")
                .then(
                    (response) => {
                        this.fetchUsers()
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
        async fetchUsers() {
            await axios.get("/api/user/get/me")
                .then((response) => {
                    this.user = response.data.user

                    if (this.user.email == null && this.user.password == null) {
                        // Twitter認証のみ且つ無料（もしくは女性）ユーザ
                        this.page_type = 0
                    }
                    else if (this.user.email != null && this.user.password == null) {
                        // Twitter認証のみ且つ課金ユーザ
                        this.page_type = 1
                        this.email = this.user.email
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        if (error.response && error.response.status == 401) {
                            window.location.href = "/auth?logout=true"
                        }
                        else {
                            this.$showErrorToast("ユーザーの取得に失敗しました")
                        }
                    }
                })
        },
    },
    mounted() {
        this.init()
    },
    computed: {
        isInValidEmail() {
            //メールアドレスとして判定される文字列と記号の組み合わせを定数化
            const reg = new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/);
            //指定した組み合わせになっていなかった場合判定を返す。
            return !reg.test(this.email);
        }
    }
}
</script>

<style scoped>
.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    height: 56px;
    width: 540px;
    top: 0;
    background-color: #fff;
    z-index: 999;
}

@media (max-width: 576px) {

    .luna-header-box {
        width: 100%;
    }
}

</style>
